import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { Btn, InputText, TextBtn } from '../../components'
import { LogoLogin } from '../../assets/imgs'
import { hideLoadingBox, showLoadingBox, showMessageBox } from '../../store/actions/system.actions'

import './Login.css'
import useLogin, { LOAD_MESSAGE, MFA_CODE_LENGTH } from './LoginHook'

const formatSeconds = totalSeconds => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

function Login({ history, dispatch }) {
  const { state, localDispatch, mfaInfo } = useLogin()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.LOGIN:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.requestUserLogin(state.userCredentials)
        break

      case LOAD_MESSAGE.MFA_VERIFY:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.verifyMfaCode(state.mfa)
        break

      case LOAD_MESSAGE.MFA_RESEND:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.resendMfaCode(state.mfa)
        break

      case LOAD_MESSAGE.MFA_PENDING:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Login efetuado', null))
        dispatch(hideLoadingBox())
        history.push('/main/home')
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage.message))
      localDispatch.onErrorShown()
    }
  }, [state.errorMessage])

  const renderLoginForm = () => (
    <div className="form">
      <InputText
        label="E-mail"
        value={state.userCredentials.email}
        onChange={value => localDispatch.onChange('email', value)}
      />
      <InputText
        type="password"
        label="Senha"
        value={state.userCredentials.password}
        onChange={value => localDispatch.onChange('password', value)}
        onEnter={localDispatch.onAcessarClicked}
      />
      <div className="text-center" style={{ marginTop: 20 }}>
        <Btn onClick={localDispatch.onAcessarClicked} isLoading={state.isLoading}>
          ACESSAR
        </Btn>
      </div>
      <div className="text-center" style={{ marginTop: 20 }}>
        <TextBtn onClick={() => history.push('/signup')}>Novo Usuário, clique aqui</TextBtn>
      </div>
      <div className="text-center" style={{ marginTop: 5 }}>
        <TextBtn onClick={() => history.push('/forgot-password')}>Esqueci a senha</TextBtn>
      </div>
    </div>
  )

  const renderMfaForm = () => (
    <div className="form">
      <p style={{ fontSize: '0.9rem', textAlign: 'left', marginTop: 20 }}>
        Enviamos um código de verificação para <strong>{state.mfa.emailMask}</strong>. Digite o
        código abaixo para concluir o acesso.
      </p>
      <InputText
        label="Código de verificação"
        value={state.mfa.code}
        onChange={localDispatch.onMfaCodeChange}
        onEnter={localDispatch.onConfirmarCodigoClicked}
        placeholder={'0'.repeat(MFA_CODE_LENGTH)}
        inputMode="numeric"
        maxLength={MFA_CODE_LENGTH}
        autoComplete="one-time-code"
        autoFocus
        disabled={mfaInfo.isExpired}
        inputStyle={{ height: 45, fontSize: '1.4rem', letterSpacing: 8, textAlign: 'center' }}
      />
      <div
        style={{
          marginTop: 8,
          fontSize: '0.8rem',
          textAlign: 'left',
          color: mfaInfo.isExpired ? '#d32f2f' : '#757575',
        }}
      >
        {mfaInfo.isExpired
          ? 'Código expirado. Solicite um novo código.'
          : `O código expira em ${formatSeconds(mfaInfo.secondsToExpire)}`}
      </div>
      <div className="text-center" style={{ marginTop: 20 }}>
        <Btn
          onClick={localDispatch.onConfirmarCodigoClicked}
          isLoading={state.isLoading}
          disabled={mfaInfo.isExpired}
        >
          CONFIRMAR
        </Btn>
      </div>
      <div className="text-center" style={{ marginTop: 20 }}>
        <TextBtn onClick={localDispatch.onReenviarCodigoClicked} disabled={!mfaInfo.canResend}>
          {mfaInfo.secondsToResend > 0
            ? `Reenviar código em ${mfaInfo.secondsToResend}s`
            : 'Reenviar código'}
        </TextBtn>
      </div>
      <div className="text-center" style={{ marginTop: 5 }}>
        <TextBtn onClick={localDispatch.backToLogin}>Voltar ao login</TextBtn>
      </div>
    </div>
  )

  return (
    <div className="Login">
      <div className="form__container">
        <img src={LogoLogin} alt="Logo Login" />
        {mfaInfo.isMfaStep ? renderMfaForm() : renderLoginForm()}
      </div>
    </div>
  )
}

export default connect()(Login)
